import { html } from 'lit-element';
import { sy_arrow_chevron_down as chevronDown } from '@aab/sc-aab-icon-set';
import { n100 } from '@aab/sc-styles-colors';

/**
 * AabSelectButton is the 'toggle' part of the AabSelect; the area on which you click to open the dropdown, which displays the selected option,
 * and displays the chevron. According to [WAI ARIA guidelines](https://www.w3.org/TR/wai-aria-practices-1.1/examples/listbox/listbox-collapsible.html),
 * it must be a <button>.
 *
 * @param {boolean} arg0.hasLabel whether or not the AabSelect has a label passed to it. Controls the ariaLabelledBy attributed
 * @param {boolean} arg0.hasValue whether or not the AabSelect has a set value. Determines whether to show the placeholder or not
 * @param {boolean} arg0.isOpen whether or not the dropdown of the AabSelect is open. Determines, among others, the direction of the chevron
 * @param {string} arg0.variant the variant style of the AabSelect, made visible through the borderColor of the AabSelectButton
 * @param {boolean} arg0.disabled whether the button should be disabled
 * @param {string} arg0.displayValue the displayValue of the AabSelectButton
 * @param {string} arg0.icon an svg string, which gets passed to an aab-icon
 * @param {function} arg0.onClick a callback for when the button has been clicked
 */
export default ({
  hasLabel,
  hasValue,
  isOpen,
  variant,
  disabled,
  noBorder,
  displayValue,
  icon,
  onClick,
}) => html`
  <button
    aria-labelledby="${hasLabel ? 'aab-select-label' : ''} aab-select-target"
    aria-haspopup="listbox"
    aria-expanded="${isOpen ? 'true' : 'false'}"
    tabindex="0"
    class=${`target ${variant ? `target--${variant}` : ''}
    ${disabled ? 'target--disabled' : ''}
    ${noBorder ? 'target--no-border' : ''}
    `}
    id="aab-select-target"
    @click=${onClick}
  >
    <span
      class="${`target__label ${!hasValue ? 'target__label--is-placeholder' : ''}`}"
    >
      ${icon && html`<aab-icon class="option-icon" size="3" svg="${icon}"></aab-icon>`}

      ${displayValue}
    </span>

    <span class=${`arrow ${isOpen ? 'arrow--flipped' : ''}`}>
      <aab-icon
        class="d-flex"
        svg=${chevronDown}
        size="3"
        color="${disabled ? n100 : ''}"
      ></aab-icon>
    </span>
  </button>
`;
